import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
// Extend Zod with OpenAPI
extendZodWithOpenApi(z);
// UUID validation
const uuidSchema = z.string().uuid('Invalid UUID format');
// Create course tag input schema
export const CreateCourseTagSchema = z
    .object({
    name: z
        .string()
        .min(1, 'Name is required')
        .max(255, 'Name must be less than 255 characters')
        .trim()
        .transform((val) => val.toLowerCase())
        .openapi({
        description: 'Course tag name',
        example: 'python',
    }),
    slug: z
        .string()
        .min(1, 'Slug is required')
        .max(255, 'Slug must be less than 255 characters')
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug must be lowercase alphanumeric with hyphens')
        .openapi({
        description: 'Course tag slug',
        example: 'python',
    }),
})
    .openapi('CreateCourseTag');
export const UpdateCourseTagSchema = z
    .object({
    name: z
        .string()
        .min(1, 'Name is required')
        .max(255, 'Name must be less than 255 characters')
        .trim()
        .transform((val) => val.toLowerCase())
        .optional()
        .openapi({
        description: 'Course tag name',
        example: 'python',
    }),
    slug: z.string().max(255, 'Slug must be less than 255 characters').optional().openapi({
        description: 'Course tag slug',
        example: 'python',
    }),
})
    .openapi('UpdateCourseTag');
// List course tags query parameters
export const ListCourseTagsQuerySchema = z.object({
    page: z
        .string()
        .optional()
        .default('1')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0, 'Page must be greater than 0'),
    pageSize: z
        .string()
        .optional()
        .default('10')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0 && val <= 100, 'Page size must be between 1 and 100'),
    sortBy: z
        .enum(['name', 'slug', 'createdAt', 'updatedAt'])
        .optional()
        .default('createdAt')
        .openapi({
        description: 'Field to sort results by',
        example: 'createdAt',
    }),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc').openapi({
        description: 'Sort direction',
        example: 'desc',
    }),
});
// Course tag ID parameter validation
export const CourseTagIdParamSchema = z.object({
    tagId: uuidSchema.openapi({
        description: 'Unique identifier of the course tag',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
// Course tag entity schema (for API responses)
export const CourseTagSchema = z
    .object({
    id: uuidSchema.openapi({ description: 'Course tag UUID' }),
    name: z.string().openapi({ description: 'Tag name', example: 'python' }),
    slug: z.string().openapi({ description: 'URL-friendly slug', example: 'python' }),
    createdAt: z.string().optional().openapi({ description: 'Creation timestamp' }),
    updatedAt: z.string().optional().openapi({ description: 'Last update timestamp' }),
})
    .openapi('CourseTag');
//# sourceMappingURL=course-tag.schema.js.map